import React, { Component } from "react";
import "./Header.css";
import { MDBRow, MDBCol } from "mdbreact";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormInicial from "../FormInicial/FormInicial";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import FormToken from "../FormToken/FormToken";

class Header extends Component {
  state = {
    open: false,
    valueTab: 0,
  };

  handleTab = (event, value) => {
    this.setState({
      valueTab: value,
    });
  };

  openDialogFormInicial = () => {
    this.setState({
      open: true,
    });
  };

  closeDialogFormInicial = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <div className="container-fluid">
        <MDBRow className="banner min-banner justify-content-end">
          <MDBCol className="col-md-7 col-lg-6 col-xl-5 p-0 d-flex align-items-cennter justify-content-center flex-column text-center wow bounceInLeft animated bg-blue-button">
            <h1 className="text-center text-white display-5 font-weit-bol font-weight-bold text-uppercase fz-r">
              DOCUMENTACI&Oacute;N
            </h1>
            <h2 className="text-center text-white display-5 font-weit-bol font-weight-bold text-uppercase fz-r">En Línea</h2>
            <button className="boton orangeReingreso marginTop mx-auto" onClick={this.openDialogFormInicial}>
              INICIAR
            </button>
          </MDBCol>
        </MDBRow>
        <Dialog open={this.state.open} maxWidth={"sm"} scroll={"body"}>
          <DialogTitle disableTypography className="dialogTitle bg-blue">
            <h6 className="h6 text-white">DOCUMENTACIÓN EN LÍNEA</h6>
            <IconButton onClick={this.closeDialogFormInicial} className="text-white">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="m-0">
            <Tabs
              value={this.state.valueTab}
              onChange={this.handleTab}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              centered
            >
              <Tab label="Formulario" />
              <Tab label="Token" />
            </Tabs>

            {this.state.valueTab === 0 && <FormInicial/>}

            {this.state.valueTab === 1 && <FormToken />}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
export default Header;
